module.exports = __webpack_public_path__ + "img/tooltip_06-vallone-wood-walnut-02.85dee54a.jpg";